export default __webpack_public_path__ + "static/media/bloodpressure.fa0e9a82.gif";